import React, { Component } from "react";
import { Modal, message } from "antd";
import ChangeAppearanceModalRender from "./children/ChangeAppearanceModalRender";
import { requsetChangeAppearance, requsetGetAppearance } from "../../../../../../api/apis";
import { GAPersonalChangeAppearanceConfirm } from "../../../../../../ga/personalCenter";
import { withTranslation } from "react-i18next";

class ChangeAppearanceModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      theme: null,
      changeAppearanceSubmitting: false,
    };
  }

  componentDidMount() {
    this.handleRequestGetAppearance();
  }

  /**
   *请求用户主题信息
   */
  handleRequestGetAppearance = () => {
    requsetGetAppearance()
      .then(res => {
        if (res.code === 200) {
          console.log(res);
          let theme = "light";
          if (res.data.appearance === "Dark") {
            theme = "dark";
          }
          this.setState({
            theme,
          });
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  /**
   *点击修改主题
   * @param {string} theme dark || light
   */
  handleChangeTheme = theme => {
    this.setState({
      theme,
    });
  };

  /**
   * 点击提交按钮
   */
  handleSubmitChangeAppearance = () => {
    this.setState({
      changeAppearanceSubmitting: true,
    });
    GAPersonalChangeAppearanceConfirm(this.state.theme === "light" ? "white" : "black");
    this.handleRequsetChangeAppearance(this.state.theme === "light" ? "Light" : "Dark");
  };

  /**
   *请求修改用户主题
   * @param {string} appearance Dark || Light 接口需要的参数首字母大写
   */
  handleRequsetChangeAppearance = appearance => {
    let formData = new FormData();
    formData.append("appearance", appearance);
    requsetChangeAppearance({
      body: formData,
    })
      .then(res => {
        if (res.code === 200) {
          message.success(this.props.t("updateSuccessTips"));
          this.props.handleVisible(false);
        }
      })
      .catch(err => {
        console.log(err);
      })
      .finally(() => {
        this.setState({
          changeAppearanceSubmitting: false,
        });
      });
  };

  /**
   *点击忘记密码
   */
  handelForgetPassword = () => {
    this.props.handleVisible(false);
    this.props.handleForgetPasswordModalVisible(true);
  };

  render() {
    const { visible, handleVisible } = this.props;
    return (
      <Modal
        getContainer={false}
        centered
        maskClosable={false}
        visible={visible}
        title={null}
        footer={null}
        width={948}
        onCancel={() => handleVisible(false)}
      >
        <ChangeAppearanceModalRender
          theme={this.state.theme}
          changeAppearanceSubmitting={this.state.changeAppearanceSubmitting}
          handleChangeTheme={this.handleChangeTheme}
          handleSubmitChangeAppearance={this.handleSubmitChangeAppearance}
        />
      </Modal>
    );
  }
}

export default withTranslation(["common"])(ChangeAppearanceModal);
